<template>
  <div v-if="podeBaixar" class="text-center" @click.stop>
    <section v-if="!checkValidade(dataVencimento)">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon style="cursor: pointer" v-bind="attrs" v-on="on" @click="baixarDae()"
          color="primary">download </v-icon>
        </template>
        <span>Baixar DAE</span>
      </v-tooltip>
    </section>
    <v-dialog v-else v-model="dialog" width="500">
      <template v-slot:activator="{ on: dialogOn, attrs: dialogAttrs }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-icon style="cursor: pointer" v-bind="{ ...dialogAttrs, ...tooltipAttrs }" v-on="{ ...dialogOn, ...tooltipOn }"
              color="primary">download</v-icon>
          </template>
          <span>Baixar DAE</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-toolbar color="primary" class="text-h6 elevation-0" dark>
          Selecione a data de vencimento
        </v-toolbar>
        <v-card-text class="pa-10">
          <v-menu v-model="vencimento.menu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field v-on="on" :value="dateVencimento" label="Data de Vencimento"
                @click:clear="vencimento.date = null" clearable outlined readonly></v-text-field>
            </template>
            <v-date-picker v-model="vencimento.date" @change="vencimento.menu = false" :min="dateMin"></v-date-picker>
          </v-menu>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false"> Cancelar </v-btn>

          <v-spacer></v-spacer>
          <v-btn :disabled="!dateVencimento" color="primary" text @click="baixarDae()" :loading="isLoadingBtn">
            BAIXAR DAE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <LoaderDialog :active-dialog="isLoadingBtn" message="Baixando DAE" />
  </div>
</template>

<script>
import { RevenueStatusList } from "@/models/financeiro/enum/revenue-status.enum";
import newNegociationService from "@/services/financeiro/new-negociation.service";
import moment from "moment";
import LoaderDialog from "./LoaderDialog.vue";

export default {
  name: "DialogBaixarDae",
  components: { LoaderDialog },
  props: {
    idReceita: { type: Number },
    status: { type: String, default: "" },
    cpfCnpj: { type: String, default: "" },
    dataVencimento: { type: String, default: "" }
  },
  data() {
    return {
      dialog: false,
      receitaStatus: [RevenueStatusList[0].value, RevenueStatusList[8].value, RevenueStatusList[13].value],
      vencimento: {
        date: null,
        menu: false,
      },
      isLoadingBtn: false,
    };
  },
  computed: {
    podeBaixar() {
      return this.receitaStatus.includes(this.status);
    },
    dateVencimento() {
      return this.vencimento.date
        ? moment(this.vencimento.date).format("DD/MM/YYYY")
        : "";
    },
    dateMin() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    acionar() {
      if (!this.checkValidade(this.dataVencimento)) {
        this.baixarDae();
      } else {
        this.dialog = true;
      }
    },
    baixarDae() {
      this.isLoadingBtn = true;
      const checkDate =  !this.vencimento.date ? this.dataVencimento : this.vencimento.date 
      newNegociationService
        .baixarDae(
          this.cpfCnpj,
          [this.idReceita.toString()],
          checkDate
        )
        .subscribe(
          (res) => {
            this.loader = false;
            const file = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.isLoadingBtn = false;
            this.vencimento = {
              date: null,
              menu: false,
            };
            this.dialog = false;
          },
          (error) => {
            this.loader = false;
            this.isLoadingBtn = false;
            GlobalStore.setSnackBar({
              show: true,
              message: "Não foi possível processar a requisição",
              type: "error",
            });
          }
        );

    },
    checkValidade(dataVencimento) {
      const date = moment(dataVencimento).format('YYYY-MM-DD')
      return moment(date).isBefore(moment(), 'day')
    }
  },

};
</script>
